import __request__ from "routing/request";
export function bulkRemove(Entitiestoremove) {
  return __request__("POST", "/datanode/bulk_remove", Entitiestoremove, {}, {
    "Accept": ["application/json"]
  });
}
export function bulkStart(Entitiestostart) {
  return __request__("POST", "/datanode/bulk_start", Entitiestostart, {}, {
    "Accept": ["application/json"]
  });
}
export function bulkStop(Entitiestostop) {
  return __request__("POST", "/datanode/bulk_stop", Entitiestostop, {}, {
    "Accept": ["application/json"]
  });
}
export function runsWithDataNode() {
  return __request__("GET", "/datanode/configured", null, {}, {
    "Accept": ["application/json"]
  });
}
export function getDataNode(nodeId) {
  return __request__("GET", `/datanode/${nodeId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function removeNode(nodeId) {
  return __request__("DELETE", `/datanode/${nodeId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function resetNode(nodeId) {
  return __request__("POST", `/datanode/${nodeId}/reset`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function startNode(nodeId) {
  return __request__("POST", `/datanode/${nodeId}/start`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function stopNode(nodeId) {
  return __request__("POST", `/datanode/${nodeId}/stop`, null, {}, {
    "Accept": ["application/json"]
  });
}
